<div class="relative w-full h-full bg-slate-50 flex flex-col overflow-hidden font-sans">

  <!-- Header Bar -->
  <div
    class="relative bg-gradient-to-b from-[#2e2f38] to-[#1a1b20] pt-5 pb-8 rounded-b-[2.5rem] shadow-lg z-10 shrink-0 text-white border-b border-white/5">

    <div class="absolute left-4 top-4 z-20">
      <button
        class="w-9 h-9 bg-white/10 hover:bg-white/20 backdrop-blur-md shadow-sm rounded-full flex justify-center items-center active:scale-95 transition-all border border-white/10 text-white outline-none"
        (click)="goback()">
        <img src="icons/arrow_back_white.svg" class="w-5 h-5" />
      </button>
    </div>

    <div class="flex flex-col items-center justify-center mt-1 text-center">
      <h2 class="text-base font-black tracking-wide text-white">
        {{ currentLang === "TH" ? "เปิดใช้งานบัตรสมาชิก" : "Activate Membership" }}
      </h2>
      <p class="text-[9px] text-amber-400 font-bold mt-1 uppercase tracking-wider">
        {{ currentLang === "TH" ? "บัตรอภินันทนาการและโปรโมชั่นพิเศษ" : "Promotional & Complimentary Passes" }}
      </p>
    </div>
  </div>

  <div class="flex-1 z-0 px-4">

    <!-- Empty State -->
    <div *ngIf="activateMemberCardList.length === 0"
      class="flex flex-col items-center justify-center py-24 text-slate-400">
      <i class="fa fa-ticket text-5xl opacity-40 mb-3"></i>
      <p class="text-xs font-bold">{{ currentLang === "TH" ? "ไม่พบรายการบัตรสมาชิกโปรโมชั่น" : "No promotional cards
        found" }}</p>
      <p class="text-[10px] text-slate-400 mt-1.5 max-w-[220px] text-center leading-normal">
        {{ currentLang === "TH" ? "กดปุ่มด้านล่างเพื่อกรอกรหัสโปรโมชั่นของคุณ" : "Tap the button below to enter your
        promo code" }}
      </p>
    </div>

    <!-- Ticket Pass List -->
    <div class="space-y-4 pt-6 h-[calc(100vh-170px)] overflow-y-auto relative custom-scrollbar pb-32">
      <div *ngFor="let member of activateMemberCardList"
        class="relative bg-gradient-to-r from-amber-500 to-amber-600 text-white rounded-3xl p-5 shadow-lg border border-white/10 overflow-hidden flex flex-col gap-4 group hover:shadow-xl hover:shadow-amber-500/10 transition-all duration-200">

        <!-- Brand & Vehicle Type -->
        <div class="flex justify-between items-start">
          <div class="flex items-center gap-3">
            <div
              class="w-12 h-12 bg-white rounded-2xl p-1.5 flex items-center justify-center shadow-inner border border-white/20">
              <img [src]="member.logo" alt="logo" class="w-full h-full object-contain mix-blend-multiply" />
            </div>
            <div class="text-left">
              <h3 class="text-sm font-black tracking-wide leading-tight line-clamp-1">{{ member.siteName }}</h3>
              <span
                class="inline-flex items-center gap-1 mt-1 text-[9px] font-bold bg-white/20 backdrop-blur-md px-2 py-0.5 rounded-full uppercase tracking-wider text-amber-100">
                <img src="icons/{{ member.vehicleId === 1 ? 'directions_car_ambar.svg' : 'two_wheeler_ambar.svg' }}"
                  class="w-5 h-5" />
                {{ member.vehicleName }}
              </span>
            </div>
          </div>
          <span class="bg-amber-400 text-slate-800 text-[9px] font-black uppercase px-2.5 py-1 rounded-full shadow-sm">
            {{ currentLang === "TH" ? "บัตรโปรโมชั่น" : "PROMO PASS" }}
          </span>
        </div>

        <!-- Ticket cut cutout mockup design -->
        <div class="border-t border-dashed border-white/30 relative my-0.5">
          <div class="absolute -left-7 -top-2 w-4 h-4 bg-slate-50 rounded-full shadow-inner"></div>
          <div class="absolute -right-7 -top-2 w-4 h-4 bg-slate-50 rounded-full shadow-inner"></div>
        </div>

        <!-- Date details -->
        <div class="flex justify-between items-center text-xs">
          <div class="flex flex-col text-left">
            <span class="text-amber-200/80 font-bold text-[8px] uppercase tracking-wider">{{ currentLang === "TH" ?
              "วันที่เริ่มใช้งาน" : "Start Date" }}</span>
            <span class="font-mono font-bold">{{ member.startDate | date : "dd/MM/yyyy" }}</span>
          </div>
          <div class="flex flex-col text-right">
            <span class="text-amber-200/80 font-bold text-[8px] uppercase tracking-wider">{{ currentLang === "TH" ?
              "วันหมดอายุเปิดใช้งาน" : "Expiry" }}</span>
            <span class="font-mono font-bold text-rose-300">{{ member.endDate | date : "dd/MM/yyyy" }}</span>
          </div>
        </div>

        <!-- Action Button -->
        <button
          class="w-full py-3 bg-white text-slate-800 rounded-2xl font-black text-xs shadow-md hover:bg-slate-100 active:scale-[0.98] transition-all flex justify-center items-center gap-1.5 border-none outline-none"
          (click)="onClickActivate(member)">
          <img src="icons/check_circle_slate_dark.svg" class="w-5 h-5" />
          {{ currentLang === "TH" ? "เปิดใช้งานบัตรสมาชิก" : "Activate Membership" }}
        </button>
      </div>
    </div>
  </div>

  <!-- Floating Action Button (FAB) -->
  <div class="absolute bottom-6 left-0 right-0 flex justify-center z-20 pointer-events-none">
    <button
      class="pointer-events-auto flex items-center gap-2 px-5 py-3.5 bg-amber-400 text-slate-800 rounded-full shadow-xl shadow-amber-400/25 active:scale-95 transition-all group hover:bg-amber-50 font-black text-xs border-none outline-none"
      (click)="showPlusModal = true; isPlusChoseForm = 'form'">
      <img src="icons/add_black.svg" class="w-5 h-5 group-hover:rotate-90 transition-transform duration-300" />
      <span>{{ currentLang === "TH" ? "กรอกรหัสเปิดใช้งาน" : "Enter Activation Code" }}</span>
    </button>
  </div>

</div>

<!-- Premium Fullscreen Loading Overlay -->
<app-pss-loading *ngIf="isLoading"></app-pss-loading>

<!-- MODAL: Add Pass (Code Form Only) -->
<div class="fixed inset-0 z-50 flex items-center justify-center p-4 animate-fade-in" *ngIf="showPlusModal">
  <div class="absolute inset-0 bg-slate-900/40 backdrop-blur-sm transition-opacity" (click)="onCloseModalPlus()"></div>

  <div
    class="bg-white w-full max-w-sm rounded-[2.5rem] shadow-2xl relative z-10 overflow-hidden transform transition-all border border-slate-100/50 animate-scale-up">
    <!-- Header -->
    <div class="px-6 py-5 bg-gradient-to-b from-[#2e2f38] to-[#1a1b20] flex justify-between items-center text-white">
      <h3 class="text-base font-black tracking-wide">
        {{ currentLang === "TH" ? "ระบุรหัสเปิดใช้งาน" : "Enter Code" }}
      </h3>
      <button
        class="w-7 h-7 rounded-full bg-white/10 hover:bg-white/20 text-white/80 hover:text-white flex items-center justify-center transition-colors border-none outline-none"
        (click)="onCloseModalPlus()">
        <img src="icons/close_slate.svg" class="w-5 h-5" />
      </button>
    </div>

    <!-- Body -->
    <div class="p-6 text-xs text-left">
      <div class="text-center mb-4">
        <!-- <img src="icons/PSS/PSS Sticker-07.png" class="w-16 h-16 drop-shadow-md mx-auto object-contain" /> -->
        <p class="text-[10px] text-slate-400 font-bold mt-1.5 leading-normal">
          {{ currentLang === "TH"
          ? "กรุณากรอกรหัสบัตรสมาชิกหรือรหัสโปรโมชั่นที่คุณได้รับเพื่อเปิดใช้งาน"
          : "Please enter the promo code you received to activate your pass" }}
        </p>
      </div>

      <div class="space-y-1.5">
        <label class="block font-bold text-slate-500 uppercase tracking-wider text-[10px]">{{ currentLang === 'TH' ?
          'รหัสบัตรสมาชิก / โปรโมชั่น' : 'Promo / Card Code' }}</label>
        <input type="text" [(ngModel)]="codeActivateMemberCard"
          class="w-full px-4 py-3 rounded-2xl border border-slate-200 focus:border-amber-400 focus:ring-1 focus:ring-amber-400 outline-none transition-all font-mono font-black placeholder:font-sans placeholder:font-normal placeholder:text-slate-400 text-sm bg-slate-50 text-slate-800"
          [placeholder]="currentLang === 'TH' ? 'ระบุรหัสเปิดใช้งานคูปอง' : 'Enter promo code'" />
        <button
          class="mt-4 w-full py-3.5 bg-amber-400 text-slate-800 rounded-2xl font-black shadow-md hover:bg-amber-500 active:scale-95 transition-all outline-none border-none text-xs"
          (click)="onClickCodeActivateMemberCard()">
          {{ currentLang === "TH" ? "ตรวจสอบสิทธิ์บัตร" : "Verify Promotion" }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- MODAL: Confirmation -->
<div class="fixed inset-0 z-[60] flex items-center justify-center p-6 animate-fade-in" *ngIf="showConfirmModal">
  <div class="absolute inset-0 bg-slate-900/40 backdrop-blur-sm" (click)="onClickConfirmActivateMemberCard(false)">
  </div>
  <div
    class="bg-white w-full max-w-sm rounded-[2.5rem] shadow-2xl z-10 p-6 text-center animate-scale-up border border-slate-100/50">
    <div
      class="w-14 h-14 bg-amber-50 rounded-full flex items-center justify-center mx-auto mb-4 border border-amber-100">
      <img src="icons/help_orange.svg" class="w-7 h-7" />
    </div>
    <h3 class="text-sm font-black text-slate-800 mb-1">{{ currentLang === "TH" ? "ยืนยันการทำรายการ?" : "Confirm
      Action?" }}</h3>
    <p class="text-xs text-slate-400 font-bold mb-6">{{ currentLang === "TH" ?
      "คุณต้องการเปิดใช้งานรหัสสมาชิกโปรโมชั่นนี้ใช่หรือไม่" : "Do you want to activate this code?" }}</p>

    <div class="flex gap-3 text-xs">
      <button
        class="flex-1 py-3 rounded-2xl border border-slate-200 text-slate-500 font-black hover:bg-slate-50 outline-none"
        (click)="onClickConfirmActivateMemberCard(false)">
        {{ currentLang === "TH" ? "ยกเลิก" : "Cancel" }}
      </button>
      <button
        class="flex-1 py-3 rounded-2xl bg-amber-400 text-slate-800 font-black shadow-md hover:bg-amber-500 outline-none border-none"
        (click)="onClickConfirmActivateMemberCard(true)">
        {{ currentLang === "TH" ? "ยืนยันเปิดใช้งาน" : "Confirm" }}
      </button>
    </div>
  </div>
</div>

<!-- MODAL: Create New Card vs Renew Card Selection Option -->
<div *ngIf="showModal_option"
  class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 backdrop-blur-sm px-3 animate-fade-in">
  <div class="bg-white w-full sm:max-w-sm rounded-[2.5rem] p-6 relative animate-scale-up border border-slate-100/50">
    <button (click)="showModal_option = false"
      class="absolute top-4 right-4 w-7 h-7 rounded-full bg-slate-50 hover:bg-slate-100 text-slate-400 hover:text-rose-500 transition-colors flex items-center justify-center outline-none border-none">✕</button>

    <div class="flex flex-col items-center text-center">
      <img src="icons/PSS/PSS Sticker-01.png" class="w-16 h-16 mb-3 drop-shadow-md object-contain" />
      <h3 class="text-sm font-black text-slate-800">
        {{ currentLang === "TH" ? "เลือกประเภทรายการ" : "Select Option" }}
      </h3>
      <p class="text-[10px] text-slate-400 font-bold mt-0.5 mb-6">
        {{ currentLang === "TH" ? "กรุณาเลือกรูปแบบที่จะดำเนินการสำหรับบัตรนี้" : "Please select how you want to assign
        this pass" }}
      </p>

      <button (click)="onClickActivateMemberCard()"
        class="w-full py-3.5 mb-3 bg-amber-400 text-slate-800 rounded-2xl font-black shadow-md hover:bg-amber-500 active:scale-[0.98] transition-all flex items-center justify-center gap-1.5 border-none outline-none text-xs">
        <img src="icons/add_card_black.svg" class="w-5 h-5" />
        {{ currentLang === "TH" ? "เปิดใช้งานบัตรสมาชิกใบใหม่" : "Create New Card" }}
      </button>
      <button (click)="onClickActivateMemberCardRenew()"
        class="w-full py-3.5 bg-white border border-slate-200 text-slate-600 rounded-2xl font-black hover:bg-slate-50 active:scale-[0.98] transition-all flex items-center justify-center gap-1.5 outline-none text-xs">
        <img src="icons/autorenew_slate_dark.svg" class="w-5 h-5" />
        {{ currentLang === "TH" ? "ต่ออายุบัตรใบเดิม" : "Renew Existing Card" }}
      </button>
    </div>
  </div>
</div>

<!-- MODAL: Select Existing Card to Renew -->
<div *ngIf="isShowCardInfoModal"
  class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/40 backdrop-blur-sm animate-fade-in">
  <div
    class="bg-white w-full max-w-sm rounded-[2.5rem] shadow-2xl flex flex-col max-h-[80vh] overflow-hidden border border-slate-100/50 animate-scale-up">
    <div class="px-6 py-4 bg-gradient-to-b from-[#2e2f38] to-[#1a1b20] flex justify-between items-center text-white">
      <h3 class="text-base font-black tracking-wide text-white">
        {{ currentLang === "TH" ? "เลือกบัตรเพื่อต่ออายุ" : "Select Card to Renew" }}
      </h3>
      <button (click)="isShowCardInfoModal = false"
        class="w-7 h-7 rounded-full bg-white/10 hover:bg-white/20 text-white/80 hover:text-white flex items-center justify-center transition-colors">
        <img src="icons/close_slate.svg" class="w-5 h-5" />
      </button>
    </div>

    <div class="overflow-y-auto p-6 space-y-3 custom-scrollbar text-xs">
      <div *ngFor="let cards of cardByVehicleTypeInfo" (click)="onClickActivateMemberCardRenewToForm(cards.cardCode)"
        class="p-4 bg-slate-50 border border-slate-100 rounded-2xl hover:border-amber-400 hover:bg-amber-400/[0.02] cursor-pointer transition-all group flex flex-col gap-2">
        <div class="flex justify-between items-center text-left">
          <span class="font-black text-slate-800 text-sm">{{ cards.licenseList }}</span>
          <span
            class="text-[9px] font-black bg-slate-200 text-slate-600 px-2 py-0.5 rounded-full uppercase tracking-wider">{{
            cards.siteName }}</span>
        </div>
        <div class="text-slate-400 space-y-1.5 text-left">
          <p class="flex items-center gap-1.5">
            <img src="icons/credit_card_slate.svg" class="w-5 h-5" />
            {{ currentLang === "TH" ? "รหัสบัตร:" : "Code:" }}
            <span class="font-mono font-bold text-slate-700">{{ cards.cardName }}</span>
          </p>
          <p class="flex items-center gap-1.5 text-rose-500 font-bold">
            <img src="icons/event_busy_red.svg" class="w-5 h-5" />
            {{ currentLang === "TH" ? "หมดอายุ:" : "Exp:" }}
            <span>{{ cards.expireDate | date : "dd/MM/yyyy" }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>